import { isValidUUID } from 'shared/utils/uuid'

/** Session-scoped thread id for AI right-rail resume (separate from full-page `ai_thread_id`). */
const AI_RAIL_THREAD_ID_KEY = 'ai_rail_thread_id'

export const getStoredAiRailThreadId = () => {
  try {
    const value = sessionStorage.getItem(AI_RAIL_THREAD_ID_KEY)
    if (!value) {
      return null
    }
    if (!isValidUUID(value)) {
      sessionStorage.removeItem(AI_RAIL_THREAD_ID_KEY)
      return null
    }
    return value
  } catch {
    return null
  }
}

export const setStoredAiRailThreadId = (threadId) => {
  if (!isValidUUID(threadId)) {
    return
  }
  try {
    sessionStorage.setItem(AI_RAIL_THREAD_ID_KEY, threadId)
  } catch {
    // sessionStorage may be unavailable in some environments
  }
}

export const clearStoredAiRailThreadId = () => {
  try {
    sessionStorage.removeItem(AI_RAIL_THREAD_ID_KEY)
  } catch {
    // sessionStorage may be unavailable in some environments
  }
}
